// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_YJ7","cls2":"LoswpPackPitch-cls2_a15 LoswpPackPitch-cls1_YJ7"};